<template>
  <div class="card-document-buttons">

    <!-- Button Preview -->
    <BaseButton
      icon="zoom"
      icon-position="right"
      color="primary"
      :url="url">
        {{ $t('message.common.buttons.preview') }}
    </BaseButton>

    <!-- Or -->
    <span class="card-document-buttons__condition" v-if="hasZip">
      {{ $t('message.common.buttons.or') }}
    </span>

    <!-- Button Download -->
    <BaseButton
      class="card-document-buttons__download"
      icon="download"
      icon-position="right"
      color="primary"
      :url="zipUrl"
      v-if="hasZip">
        {{ $t('message.common.buttons.download') }}
    </BaseButton>

    <!-- Button Favorite -->
    <BaseButton
      class="card-document-buttons__favorite"
      :icon="bookmarkIcon"
      color="primary"
      @click.native="handleFavoriteClick"
      clear />
  </div>
</template>

<script>
import BaseButton from '@base/BaseButton'
import { fetchPostService } from '@modules/api'
export default {
  name: 'CardDocumentButtons',
  props: {
    guid: {
      type: [Number, String],
      required: true
    },
    url: {
      type: String,
      required: true
    },
    zipUrl: {
      type: String,
      required: true
    },
    bookmarked: {
      type: Boolean,
      required: true
    }
  },
  components: {
    BaseButton
  },
  data () {
    return {
      bookmarkedOption: this.bookmarked
    }
  },
  watch: {
    bookmarked () {
      this.bookmarkedOption = this.bookmarked
    }
  },
  computed: {
    hasZip () {
      return this.zipUrl !== ''
    },
    bookmarkIcon () {
      return (this.bookmarkedOption) ? 'bookmark-favorite' : 'bookmark'
    }
  },
  methods: {
    handleFavoriteClick () {
      fetchPostService('bookmark-document', { guid: this.guid })
      this.bookmarkedOption = !this.bookmarkedOption
    }
  }
}
</script>

<style lang="scss">
  .card-document-buttons{
    @media print {
      display: none !important;
    }
    padding-top: layout("spacing")/2;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    > *{
      flex: 0 1 auto;
    }

    // Card Document SMALL

    .card-document--small &{
      .button{
        padding: 0.4em 1em;
        font-size: 1.3rem;
      }
    }

    // Card Document LARGE

    .card-document--large &{
      padding-top: 0;
      .button{
        @include background-color(transparent, transparent);
        @include text-color(colors("primary"), shade(colors("primary"), 20%));
        padding: 0;
        margin: 0 layout("spacing")/2;

        .icon{
          margin: 0;
          font-size: 2.7rem;
        }
        span{
          @include hide-visually;
        }
      }
    }

    // Favorite

    &__favorite{
      margin-left: auto;
       .card-document--small &{
        display: none;
      }
    }

    // Download

    &__download{
      .card-document--small &{
        .icon{
          margin: 0;
        }
        span{
          display: none;
        }
      }
    }
    // Condition

    &__condition{
      margin: 0 layout("spacing")/2;
      color: rgba(black, .4);
      font-size: 1.4rem;

      .card-document--large &{
        display: none;
      }
    }

    .is-clear{
      .icon:before{
        font-size: 3.5rem;
      }
    }
  }
</style>
